module.exports = __webpack_public_path__ + "img/single-spline.e4cfeb74.png";